let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jiWRz")).then(() => parcelRequire('c6Dm5'));